class ThemeManager {
    constructor() {
        this.themes = new Map();
        this.activeTheme = null;
        this.defaultTheme = 'light';
        this.themeChangeCallbacks = new Set();
    }

    registerTheme(name, theme) {
        this.themes.set(name, this.processTheme(theme));
        
        // İlk tema varsayılan olarak ayarlanır
        if (!this.activeTheme) {
            this.setTheme(name);
        }
    }

    processTheme(theme) {
        return {
            ...theme,
            variables: this.flattenVariables(theme.variables)
        };
    }

    flattenVariables(variables, prefix = '') {
        const flattened = {};
        
        for (const [key, value] of Object.entries(variables)) {
            if (typeof value === 'object' && value !== null) {
                Object.assign(
                    flattened,
                    this.flattenVariables(value, `${prefix}${key}-`)
                );
            } else {
                flattened[`--${prefix}${key}`] = value;
            }
        }
        
        return flattened;
    }

    setTheme(name) {
        if (!this.themes.has(name)) {
            console.error(`Theme "${name}" not found`);
            return;
        }

        const theme = this.themes.get(name);
        this.activeTheme = name;

        // CSS değişkenlerini uygula
        this.applyThemeVariables(theme.variables);

        // Component stillerini güncelle
        this.updateComponentStyles(theme.components);

        // Callback'leri çağır
        this.notifyThemeChange(name);
    }

    applyThemeVariables(variables) {
        const root = document.documentElement;
        
        // Önceki tema değişkenlerini temizle
        const oldVars = Array.from(root.style)
            .filter(prop => prop.startsWith('--'));
            
        oldVars.forEach(prop => root.style.removeProperty(prop));

        // Yeni tema değişkenlerini uygula
        Object.entries(variables).forEach(([key, value]) => {
            root.style.setProperty(key, value);
        });
    }

    updateComponentStyles(components) {
        if (!components) return;

        // Mevcut stil elementlerini temizle
        document.querySelectorAll('style[data-theme]')
            .forEach(el => el.remove());

        // Component stillerini uygula
        Object.entries(components).forEach(([name, styles]) => {
            const styleEl = document.createElement('style');
            styleEl.setAttribute('data-theme', this.activeTheme);
            styleEl.setAttribute('data-component', name);
            styleEl.textContent = styles;
            document.head.appendChild(styleEl);
        });
    }

    onThemeChange(callback) {
        this.themeChangeCallbacks.add(callback);
        return () => this.themeChangeCallbacks.delete(callback);
    }

    notifyThemeChange(themeName) {
        this.themeChangeCallbacks.forEach(callback => callback(themeName));
    }

    getThemeVariable(name) {
        return getComputedStyle(document.documentElement)
            .getPropertyValue(`--${name}`).trim();
    }
}

export default new ThemeManager(); 